/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerAttributesMap
 */
export interface CustomerAttributesMap {
    [key: string]: string;
}


/**
 * Check if a given object implements the CustomerAttributesMap interface.
 */
export function instanceOfCustomerAttributesMap(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CustomerAttributesMapFromJSON(json: any): CustomerAttributesMap {
    return CustomerAttributesMapFromJSONTyped(json, false);
}

export function CustomerAttributesMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerAttributesMap {
    return json;
}

export function CustomerAttributesMapToJSON(value?: CustomerAttributesMap | null): any {
    return value;
}

